import { render, staticRenderFns } from "./s1.vue?vue&type=template&id=48bb3e9b&scoped=true"
var script = {}
import style0 from "./s1.vue?vue&type=style&index=0&id=48bb3e9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bb3e9b",
  null
  
)

export default component.exports